/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var n,u;function I(n){return null!=n?.cubeMap}function N(n){return null!=n&&!n.running}!function(n){n[n.RENDERING=0]="RENDERING",n[n.FADING=1]="FADING",n[n.FINISHED=2]="FINISHED"}(n||(n={})),function(n){n[n.RG=0]="RG",n[n.BA=1]="BA"}(u||(u={}));export{n as CloudsRenderingStages,u as CloudsTextureChannels,N as ensureClouds,I as isReadyCloudsData};
